@use "../../../../../styles/Colors.scss" as Colors;
@use "../../../../../styles/Constants.scss" as Constants;

.status-tooltip {

	&__time-sheet {
		display: flex;
		flex-flow: row;
		gap: Constants.$val-spacing-xs;
		margin-bottom: Constants.$val-spacing-s;
		margin-top: Constants.$val-spacing-m;

		&__label {
			font-size: Constants.$val-fontSizeXSmall;
		}
	}
}